<template>
  <div class="container">
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <h1 class="headline pa-3">Upload the organization logo</h1>
          <v-alert :value="true" v-if="progbar" type="success">{{istatus}}</v-alert>
          <v-alert :value="true" v-if="progerror" type="error">{{istatus}}</v-alert>
          <v-img src="downloadURL" height="300px"></v-img>
          <input id="input" type="file" @change="onFileChanged">
          <v-btn @click="onUpload" class="teal white--text">Upload!</v-btn>
          <v-card-title v-model="user" class="grey"></v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { db, auth, storage } from "@/fb";
import router from "../router.js";
var file = null;
var formData = null;
var newurl = "0 %";
const storageRef = storage.ref();
export default {
  data() {
    return {
      selectedFile: null,
      disabled: "disabled",
      progbar: false,
      progerror: false,
      filename: "",
      downloadURL: "",
      istatus: "0% Complete",
      user: ""
    };
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    this.downloadURL = newurl;
  },
  methods: {
    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
      this.user = auth.currentUser.uid;
      this.disabled = "!disabled";
    },
    onUpload() {
      this.progbar = true;
      // upload file, get it from this.selectedFile
      var uploadTask = storageRef
        .child("profileimages/" + auth.currentUser.uid + ".png")
        .put(this.selectedFile);
      uploadTask.on(
        "state_changed",
        snapshot => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.istatus = "Upload is " + Math.round(progress) + "% done";
        },
        error => {
          // Handle unsuccessful uploads
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            db.collection("members")
              .doc(auth.currentUser.uid)
              .update({
                photourl: downloadURL
              })
              .then(() => {
                this.downloadURL = downloadURL;
                console.log(this.downloadURL);

                /*  newurl = downloadURL;
                if (newurl != "") {
                  db.collection("members")
                    .doc(auth.currentUser.uid)
                    .update({
                      photourl: downloadURL
                    })
                    .then(() => {
                      this.downloadURL = photourl;
                      this.progbar = true;
                      this.progerror = false;
                      this.istatus = " Profile logo successfully updated!";
                      router.push({ path: "profile" });
                    })
                    .catch(error => {
                      this.progbar = false;
                      this.progerror = true;
                      this.istatus = "Error writing document: " + error;
                    });   
                } */
              });
          });
        }
      );
    }
  }
};
</script>
<style scoped>
#input {
  margin-left: 20px;
}
</style>
